import React from 'react';
import './LoadingPopup.css';
import SpaceInvadersGame from '../games/SpaceInvadersGame';

interface LoadingPopupProps {
  isOpen: boolean;
  message?: string;
  isAdmin?: boolean;
}

const LoadingPopup: React.FC<LoadingPopupProps> = ({ 
  isOpen, 
  message = 'Analyzing your data with AI...',
  isAdmin = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="loading-popup-overlay">
      <div className={`loading-popup ${isAdmin ? 'admin-popup' : ''}`}>
        {isAdmin ? (
          <>
            <h2>Administrator Mode</h2>
            <p>{message}</p>
            <SpaceInvadersGame isRunning={true} />
            <p className="admin-note">Play while you wait!</p>
          </>
        ) : (
          <>
            <div className="loading-spinner"></div>
            <h2>Please Wait</h2>
            <p>{message}</p>
            <div className="pulse-dots">
              <span className="pulse-dot"></span>
              <span className="pulse-dot"></span>
              <span className="pulse-dot"></span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoadingPopup; 